<template>
  <!-- MOB M1-3 (K4): mobil uygulamada ağır ekranlar (router meta.mobil === 'masaustu') açılırken kısa uyarı.
       «Devam» o ekranı bu oturum boyunca bir daha sormaz; web'de hiç görünmez. -->
  <Dialog
    :visible="gorunur"
    modal
    :closable="false"
    :draggable="false"
    :showHeader="false"
    :style="{ width: '92vw', maxWidth: '420px' }"
    contentClass="!p-0"
  >
    <div class="px-6 pt-8 pb-6 text-center">
      <div class="w-16 h-16 mx-auto rounded-full zemin-bilgi renk-bilgi flex items-center justify-center mb-4">
        <i class="pi pi-desktop" style="font-size: 1.9rem" />
      </div>
      <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 mb-2">Bu ekran telefonda zor kullanılır</h2>
      <p class="text-sm text-slate-500 dark:text-slate-400 leading-relaxed mb-6">
        <b>{{ baslik }}</b> geniş ekran için tasarlandı. Bilgisayarınızdan <b>panel.hepy.app</b> adresinde
        açmanız önerilir.
      </p>
      <div class="flex gap-3 justify-center">
        <Button severity="secondary" outlined class="min-h-[44px] flex-1" @click="geri">
          <i class="pi pi-arrow-left"></i> Geri
        </Button>
        <Button class="min-h-[44px] flex-1" @click="devam">
          Devam <i class="pi pi-arrow-right"></i>
        </Button>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { yerelUygulama } from "@/services/platform";

// Oturum (uygulama açık kaldığı) boyunca «Devam» denilen ekranlar; uygulama yeniden açılınca sıfırlanır.
const gecilen = new Set();

export default {
  data() {
    return { gorunur: false, anahtar: "" };
  },
  computed: {
    baslik() {
      return (this.$route.meta && this.$route.meta.title) || "Bu ekran";
    },
  },
  watch: {
    $route: { immediate: true, handler: "_kontrol" },
  },
  methods: {
    _kontrol(to) {
      if (!yerelUygulama || !to) { this.gorunur = false; return; }
      const agir = to.matched.some((r) => r.meta && r.meta.mobil === "masaustu");
      // Anahtar route kaydı: /studio/dersduzenle/:id'nin her kaydı için ayrı sorulmaz.
      this.anahtar = to.matched.length ? to.matched[to.matched.length - 1].path : to.path;
      this.gorunur = agir && !gecilen.has(this.anahtar);
    },
    devam() {
      gecilen.add(this.anahtar);
      this.gorunur = false;
    },
    geri() {
      this.gorunur = false;
      if (window.history.state && window.history.state.back) this.$router.back();
      else this.$router.replace("/admin/main");
    },
  },
};
</script>
